<template lang="pug">
  v-card.planning-table-empty
    svg.planning-table-empty__icon
      use(xlink:href="/svg/sprite.svg#icon-factory")

    h2.planning-table-empty__title {{ 'base.planning_table_empty' | translate }}
    v-btn(:disabled="isConsultant" @click="$emit('open-create')") {{ 'base.add_preparation' | translate }}

</template>

<script>
export default {
  name: 'PlanningTableEmpty'
}
</script>

<style lang="scss" scoped>
  @import '@/sass/abstracts/_mixins.scss';

  .planning-table-empty {
    position: relative;
    height: 48rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &__icon {
      position: absolute;
      height: 33rem;
      width: 33rem;
      opacity: 0.05;
      left: 8rem;
      top: 50%;
      transform: translateY(-50%);

      @include mobile {
        height: 28rem;
        width: 28rem;
        left: 5rem;
      }
    }

    &__title {
      font-size: 2.4rem;
      font-weight: 700;
      margin-bottom: 3rem;

      @include mobile {
        font-size: 2.2rem;
      }
    }
  }
</style>
